import React, {
  Component
} from 'react';
import hangman from './svgs/hangmanNone.svg';
// import hangman from './svgs/lose/hangmanGameover4.svg';
import hangmanStrike1 from './svgs/hangmanStrike1.svg';
import hangmanStrike2 from './svgs/hangmanStrike2.svg';
import hangmanStrike3 from './svgs/hangmanStrike3.svg';

import hangmanStrike40 from './svgs/strike4/hangmanStrike4-0.svg';
import hangmanStrike41 from './svgs/strike4/hangmanStrike4-1.svg';
import hangmanStrike42 from './svgs/strike4/hangmanStrike4-2.svg';
import hangmanStrike43 from './svgs/strike4/hangmanStrike4-3.svg';
import hangmanStrike44 from './svgs/strike4/hangmanStrike4-4.svg';

import hangmanStrike5 from './svgs/hangmanStrike5.svg';
import hangmanStrike6 from './svgs/hangmanStrike6.svg';

import hangmanGameover0 from './svgs/lose/hangmanGameover0.svg';
import hangmanGameover1 from './svgs/lose/hangmanGameover1.svg';
import hangmanGameover2 from './svgs/lose/hangmanGameover2.svg';
import hangmanGameover3 from './svgs/lose/hangmanGameover3.svg';
import hangmanGameover4 from './svgs/lose/hangmanGameover4.svg';

import hangmanWin0 from './svgs/win/hangmanWin0.svg';
import hangmanWin1 from './svgs/win/hangmanWin1.svg';
import hangmanWin2 from './svgs/win/hangmanWin2.svg';
import hangmanWin3 from './svgs/win/hangmanWin3.svg';
import hangmanWin4 from './svgs/win/hangmanWin4.svg';

import { Button, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';

import axios from 'axios';



import Keeb from './keeb';
import Letters from './letters';
import wordbank from './workbank';

import './App.css';

let loss = {
  color: 'red',
  marginTop: '3px',
  marginBottom: '3px',
};

let win = {
  color: 'green',
  marginTop: '3px',
  marginBottom: '3px',
};

let submenu = {
  marginTop: '3px',
  marginBottom: '3px',
};

let alphabet = {
  a: 1,
  b: 3,
  c: 3,
  d: 2,
  e: 1,
  f: 4,
  g: 2,
  h: 4,
  i: 1,
  j: 8,
  k: 5,
  l: 1,
  m: 3,
  n: 1,
  o: 1,
  p: 3,
  q: 10,
  r: 1,
  s: 1,
  t: 1,
  u: 1,
  v: 4,
  w: 4,
  x: 8,
  y: 4,
  z: 10
}

class App extends Component {
  constructor(props) {
    super(props);
    var rand = wordbank[Math.floor(Math.random()*wordbank.length)];
    var randarr = rand.split('');
    randarr = randarr.filter(function(str) {
      return /\S/.test(str);
    });
    var letter, i, sum = 0;
    for (i = 0; i < rand.length; i++) {
        letter = rand[i];
        if(letter !== ' ') {
          sum += alphabet[letter];
        }
    }
    sum = sum * 100;
    this.state = {
      logo: hangman,
      strike: 0,
      word: rand,
      arrword: randarr,
      guesses: [],
      gameover: false,
      won: false,
      score: sum,
      damage: sum/7,
      leaderboardData: [],
      highscoresOpen: false,
      name: '',
      submitted: false,
      lowestScore: 0,
    };
    this.toggleLegs = this.toggleLegs.bind(this);
    this.checkLetter = this.checkLetter.bind(this);
    this.arrayContainsArray = this.arrayContainsArray.bind(this);
    this.newGame = this.newGame.bind(this);
    this.toggle = this.toggle.bind(this);
    this.submitScore = this.submitScore.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getLeaderboardData = this.getLeaderboardData.bind(this);

  }

  toggle() {
    this.setState({
      highscoresOpen: !this.state.highscoresOpen,
    });
  }

  handleChange(e) {
    this.setState({ name: e.target.value });
  }

  componentDidMount() {
    this.getLeaderboardData();

    // const myHeaders = new Headers();
    // fetch('https://www.jsausa.com/arcade/api/hiscore/hangwayne', {
    //   method: 'GET',
    //   headers: myHeaders,
    // }).then(response => response.json()).then((json) => {
    //   this.setState({ leaderboardData: json.result });
    // }).catch((err) => {
    //   console.log(`err ${err}`);
    // });
  }

  getLeaderboardData() {
    axios.get('https://www.jsausa.com/arcade/api/hiscore/hangwayne')
    .then((leader) => {
      // console.log(leader.data.result);
      this.setState({ leaderboardData: leader.data.result });
      if(leader.data.result !== undefined) {
        let low = leader.data.result[0].score;
        let arr = leader.data.result;
        for(let i=0;i<arr.length;i++) {
          if(arr[i].score < low) {
            low = arr[i].score;
          }
        }
        this.setState({ lowestScore: low });
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  newGame() {
    var rand = wordbank[Math.floor(Math.random()*wordbank.length)];
    var randarr = rand.split('');
    randarr = randarr.filter(function(str) {
      return /\S/.test(str);
    });
    var letter, i, sum = 0;
    for (i = 0; i < rand.length; i++) {
        letter = rand[i];
        if(letter !== ' ') {
          sum += alphabet[letter];
        }
    }
    sum = sum * 100;
    this.setState({
      logo: hangman,
      strike: 0,
      word: rand,
      arrword: randarr,
      guesses: [],
      gameover: false,
      won: false,
      score: sum,
      damage: sum/7,
      leaderboardData: [],
      highscoresOpen: false,
      name: '',
      submitted: false,
      lowestScore: 0,
    });
    this.getLeaderboardData();
  }

  arrayContainsArray (superset, subset) {
    if (0 === subset.length) {
      return false;
    }
    return subset.every(function (value) {
      return (superset.indexOf(value) >= 0);
    });
  }

  submitScore() {
    if (!this.state.submitted) {
      axios.get('https://www.jsausa.com/arcade/api/ticket/hangwayne')
        .then((response) => {
          // console.log(response);
          axios.post('https://www.jsausa.com/arcade/api/hiscore/hangwayne', {
            name: this.state.name,
            score: this.state.score,
            ticket: response.data.result,
          }).then(() => {
            axios.get('https://www.jsausa.com/arcade/api/hiscore/hangwayne')
              .then((leader) => {
                // this.setState({});
                this.setState({
                  submitted: true,
                  leaderboardData: leader.data.result,
                });
              })
              .catch((error) => {
                console.log(error);
              });
          })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  toggleLegs(e) {
    // e.preventDefault();
    let num = Math.floor((Math.random() * 5));


    switch (this.state.strike) {
      case 0:
        this.setState({
          logo: hangmanStrike1,
          strike: this.state.strike + 1,
          score: Math.round(this.state.score - this.state.damage)
        });
        break;
      case 1:
        this.setState({
          logo: hangmanStrike2,
          strike: this.state.strike + 1,
          score: Math.round(this.state.score - this.state.damage)
        });
        break;
      case 2:
        this.setState({
          logo: hangmanStrike3,
          strike: this.state.strike + 1,
          score: Math.round(this.state.score - this.state.damage)
        });
        break;


      case 3:
        // let num = Math.floor((Math.random() * 5));
        
        switch (num) {
          case 0:
            this.setState({
              logo: hangmanStrike40,
              strike: this.state.strike + 1,
              score: Math.round(this.state.score - this.state.damage)
            });
            break;
          case 1:
            this.setState({
              logo: hangmanStrike41,
              strike: this.state.strike + 1,
              score: Math.round(this.state.score - this.state.damage)
            });
            break;
          case 2:
            this.setState({
              logo: hangmanStrike42,
              strike: this.state.strike + 1,
              score: Math.round(this.state.score - this.state.damage)
            });
            break;
          case 3:
            this.setState({
              logo: hangmanStrike43,
              strike: this.state.strike + 1,
              score: Math.round(this.state.score - this.state.damage)
            });
            break;
          case 4:
            this.setState({
              logo: hangmanStrike44,
              strike: this.state.strike + 1,
              score: Math.round(this.state.score - this.state.damage)
            });
            break;
          default:
            break;  
        }
        // this.setState({
        //   logo: hangmanStrike4,
        //   strike: this.state.strike + 1,
        //   score: Math.round(this.state.score - this.state.damage)
        // });
        break;


      case 4:
        this.setState({
          logo: hangmanStrike5,
          strike: this.state.strike + 1,
          score: Math.round(this.state.score - this.state.damage)
        });
        break;
      case 5:
        this.setState({
          logo: hangmanStrike6,
          strike: this.state.strike + 1,
          score: Math.round(this.state.score - this.state.damage)
        });
        break;
      case 6:
        
        switch (num) {
          case 0:
            this.setState({
              logo: hangmanGameover0,
              strike: this.state.strike + 1,
              gameover: true,
              score: 0
            });
            break;
          case 1:
            this.setState({
              logo: hangmanGameover1,
              strike: this.state.strike + 1,
              gameover: true,
              score: 0
            });
            break;
          case 2:
            this.setState({
              logo: hangmanGameover2,
              strike: this.state.strike + 1,
              gameover: true,
              score: 0
            });
            break;
          case 3:
            this.setState({
              logo: hangmanGameover3,
              strike: this.state.strike + 1,
              gameover: true,
              score: 0
            });
            break;
          case 4:
            this.setState({
              logo: hangmanGameover4,
              strike: this.state.strike + 1,
              gameover: true,
              score: 0
            });
            break;
          default:
            break;  
        }
        // this.setState({
        //   logo: hangmanGameover0,
        //   strike: this.state.strike + 1,
        //   gameover: true,
        //   score: 0

        // });
        break;
      default:
        this.setState({
          logo: hangman,
          strike: 0,
          gameover: false
        });
        break;
    }
  }

  checkLetter(l) {
    var joined = this.state.guesses.concat(l);
    this.setState({ guesses: joined },function(){
      // console.log(this.state.guesses);
      if(this.state.word.includes(l)) {
        if(this.arrayContainsArray(this.state.guesses,this.state.arrword)) {
          let num = Math.floor((Math.random() * 5));
        
        switch (num) {
          case 0:
            this.setState({
              logo: hangmanWin0,
              gameover: true,
              highscoresOpen: true,
              won: true,
            });
            break;
          case 1:
            this.setState({
              logo: hangmanWin1,
              gameover: true,
              highscoresOpen: true,
              won: true,
            });
            break;
          case 2:
            this.setState({
              logo: hangmanWin2,
              gameover: true,
              highscoresOpen: true,
              won: true,
            });
            break;
          case 3:
            this.setState({
              logo: hangmanWin3,
              gameover: true,
              highscoresOpen: true,
              won: true,
            });
            break;
          case 4:
            this.setState({
              logo: hangmanWin4,
              gameover: true,
              highscoresOpen: true,
              won: true,
            });
            break;
          default:
            break;  
        }
          // this.setState({
          //   gameover: true,
          //   won: true,
          //   logo: hangmanWin
          // });
          // console.log('game over, you win');
        }
      } else {
        this.toggleLegs();
      }
    })
    
  }
  

  render() {
    return ( 
      <div className = "App" >

      <Modal isOpen={this.state.highscoresOpen} toggle={this.toggle} style={{ color: '#000', fontSize: '1rem' }}>
          <ModalHeader toggle={this.toggle}>Highscores</ModalHeader>
          <ModalBody>
          
          
          { this.state.gameover && !this.state.submitted ? 
            <div> 
              <h4>You scored {this.state.score} points!</h4>

              { this.state.score > this.state.lowestScore ? 
              <div>
              
                <Form>
                  <FormGroup>
                    <Label for="name">Whats your name?</Label>
                    <Input
                      type="textarea"
                      name="text"
                      id="name"
                      value={this.state.name}
                      placeholder="What's your name?"
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Form>
                
                <Button onClick={this.submitScore}>Submit Score</Button>
              </div>
              : null }
            <p>Close this window and click New Game to try again!</p>
            </div>
            : null}
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Points</th>
                </tr>
              </thead>
              <tbody>
                {this.state.leaderboardData !== undefined && this.state.leaderboardData.map((obj, index) => (
                 
                  <tr key={`${obj.name}${obj.score}`}>
                    <td>{index + 1}</td>
                    <td>{obj.name}</td>
                    <td>{obj.score}</td>
                  </tr>))
                }
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>Close</Button>
          </ModalFooter>
        </Modal>

      <header className = "App-header" >
      <h1 style={submenu} >Hang Wayne!</h1> 
      <h4>Solve the vegan words</h4>
      <h4 style={loss} className={(this.state.gameover === true && this.state.won === false) ? '' : 'hide'}>You lose!</h4>
      <h4 style={win} className={(this.state.gameover === true && this.state.won === true) ? '' : 'hide'}>You Win!</h4>
      <p style={submenu}>Score: {this.state.score}</p>
      <p style={submenu} className={(this.state.gameover === false) ? '' : 'hide'}>Guesses: {this.state.strike}/6</p>
      <div className="container"><img src = {this.state.logo} className = "App-logo" alt = "logo"/></div>
      
      <Letters
          word={this.state.word}
          reveal={this.state.gameover}
          guesses={this.state.guesses}/>
      <Keeb
          onPress={this.checkLetter}
          enabled={!this.state.gameover}
          disabledLetters={this.state.guesses}/>
      <div className="buttonGroups">
        <button className="newGame" onClick={this.newGame}>New Game</button>
        <button className="highscores" onClick={this.toggle}>Highscores</button>
      </div>
      </header > 
      </div>
    );
  }
}

export default App;